var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// --- helper to build stable snapshot without positions and service fields ---
export const buildSnapshot = (nodes, edges, name) => {
    const cleanNodes = nodes.map(n => ({
        id: n.id,
        type: n.type,
        data: (() => {
            const _a = n.data, { _forceUpdate } = _a, rest = __rest(_a, ["_forceUpdate"]);
            return rest;
        })()
    })).sort((a, b) => a.id.localeCompare(b.id));
    const cleanEdges = edges.map(e => ({
        source: e.source,
        sourceHandle: e.sourceHandle,
        target: e.target,
        targetHandle: e.targetHandle
        // intentionally omit connectionType – it is an auxiliary field that does not affect the actual structure
    })).sort((a, b) => (a.source + (a.sourceHandle || '') + a.target + (b.targetHandle || '')).localeCompare(b.source + (b.sourceHandle || '') + b.target + (b.targetHandle || '')));
    return JSON.stringify({ name, nodes: cleanNodes, edges: cleanEdges });
};
